import { useEffect } from "react";
import closeImg from "../../../assets/images/svgicons/close-sm.svg";

type ScormExercisePoc={
  programId?:string;
  programName?:string;
  courseId?:string;
  userId?:string;
  exerciseId?:string;
  playVideo:(s:boolean)=>void;
  updateCompaletedStatus:()=>void;
}

// Function to open the iframe with the SCORM exercise and update the completed status when the iframe is closed.
export const ScormExercisePoc: React.FC<ScormExercisePoc|any> = ({programId,programName,courseId,playVideo,userId,exerciseId})=>{
  let url:string =import.meta.env.VITE_APP_SCORM_EXERCISE;
  url+=`?userId=${userId}`
  
    // Append programId, programName, courseId, and exerciseId to the URL.
    if(programId){
      url+=`&programId=${programId}`
    }
    if(programName){
      url+=`&programName=${programName}`
    }
    if(courseId){
      url+=`&courseId=${courseId}`
    }
    if(exerciseId){
      url+=`&exerciseId=${exerciseId}`
    }
    useEffect(() => {
      // Listen for iframe messages and close the iframe when exercise is closed.
      // This should be handled by the iframe itself, but we're using a workaround here.
      // The iframe sends a message with type 'status:close' when it's closed.
      // When we receive this message, we close the iframe and disable the playVideo function.

      // Capture event and handle it when iframe is closed.
      // We use window.addEventListener and window.removeEventListener to capture and remove the event listener.

      // Function to close the iframe when exercise is closed.
      // This should be handled by the iframe itself, but we're using a workaround here.
      // The iframe sends a message with type 'status:close' when it's closed.
      // When we receive this message, we close the iframe and disable the playVideo function.

      // Capture event and handle it when iframe is closed.
      const captureEvent = (event: any) => {
        // Handle close exercise
        if (event?.data?.type === 'status:close') {
          window.removeEventListener('message', captureEvent);
        }
        
        // Handle completion of exercise
        if (event?.data?.type === 'status:success') {
          closeIframe(); 
        }
      };
      
      // Add event listener to capture iframe messages and close the iframe when exercise is closed.
      window.addEventListener('message', captureEvent);
      return () => {
        window.removeEventListener('message', captureEvent);
      };
    }, []);
    // Function to close the iframe when exercise is closed
    const closeIframe = () => {
      // Scroll to top on close exercise
      window.scrollTo(0, 0);
      playVideo(false); //enable for close exercise
      document.body.classList.remove('overflow-y-hidden')
    }
    
    const onLoadIframeframe = () => {
      document.getElementById("mainCloseBtn")?.classList.remove('hidden')
      document.body.classList.add('overflow-y-hidden')
     }
    return (
        <div className="flex flex-col exercise-card">
            <div id='mainCloseBtn' className="hidden items-end justify-end close-btn bg-gray-700 px-[10px] py-[8px] h-auto mt-3 rounded-sm max-sm:right-4">
              <span className="cursor-pointer text-[20px] font-opensansLight" onClick={closeIframe} >
                <img src={closeImg} alt={" "} className="w-[16px] h-[16px] ml-[1px]" />
              </span>
            </div>
            <iframe
              src={url}
              title="HTML Viewer"
              onLoad={onLoadIframeframe}
              className={`exercise-iframe`}
              allowFullScreen
            />
        </div>
      )
}